import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FEEDBACK_REPORT_REPOSITORY } from '../domain/repositories/feedback-report.repository';
import { FeedbackReportRemoteDatasource } from './datasources/remote/feedback-report.remote-datasource';
import { FeedbackReportMapper } from './mappers/feedback-report.mapper';
import { FeedbackReportRepositoryImpl } from './repositories/feedback-report.repository.impl';
import { FEEDBACK_REPORT_ENDPOINT } from './datasources/feedback-report-endpoint.token';

export function provideFeedbackData(endpointFactory?: () => () => string): EnvironmentProviders {
  return makeEnvironmentProviders([
    FeedbackReportMapper,
    FeedbackReportRemoteDatasource,
    { provide: FEEDBACK_REPORT_REPOSITORY, useClass: FeedbackReportRepositoryImpl },
    ...(endpointFactory
      ? [{ provide: FEEDBACK_REPORT_ENDPOINT, useFactory: endpointFactory }]
      : []),
  ]);
}
